import { createBrowserRouter } from "react-router-dom";
import GuardRouter from "./guard-router";
import Login from "./pages/Login/Login";
import Users from "./pages/AdminConsole/Users/Users";

import Variety from "./pages/master/variety/Variety";
import CollectionCenters from "./pages/master/collectioncenters/CollectionCenters";
import Unit from "./pages/master/unit/Unit";
import Tax from "./pages/master/tax/Tax";
import RateCard from "./pages/master/ratecard/RateCard";
import Roles from "./pages/AdminConsole/Roles & Permissions/Roles";
import Billing from "./pages/AdminConsole/Billing/Billing";
import Support from "./pages/AdminConsole/Support/Support";
import Settings from "./pages/AdminConsole/Settings/Settings";
import MRPRateCard from "./pages/master/mrprate/MRPRateCard";
import Warehouse from "./pages/master/warehouse/Warehouse";
import Department from "./pages/master/department/department";
import QualityCheckParameter from "./pages/master/qualityCheckParameter/qualityCheckParameter";
import Holidays from "./pages/master/holidays/Holidays";
import FinancialYear from "./pages/master/Financial Year/FinancialYear";
import MRL from "./pages/master/mrl/MRL";
import LeaveTemplate from "./pages/master/LeaveTemplate/LeaveTemplate";
import SalaryHead from "./pages/master/salaryHead/SalaryHead";
import Product from "./pages/master/item/Product";
import AccountGroup from "./pages/FinanceManagement/AccountGroup/AccountGroup";
import AccountSubgroup from "./pages/FinanceManagement/AccountSubgroup/AccountSubgroup";
import Bank from "./pages/FinanceManagement/Bank/Bank";
import AccountDetail from "./pages/FinanceManagement/AccountDetail/AccountDetail";
import AccountMapping from "./pages/FinanceManagement/AccountMapping/AccountMapping";
import AccountTransactionConfigurationList from "./pages/FinanceManagement/AccountTransactionConfiguration/AccountTransactionConfigurationList";
import Voucher from "./pages/FinanceManagement/PaymentVoucher/Voucher";
import ProcurementTarget from "./pages/Procurement/ProcurementTarget/ProcurementTarget";
import DiscountApproval from "./pages/Procurement/DiscountApproval/DiscountApproval";
import BeatPlan from "./pages/Procurement/BeatPlan/BeatPlan";
import AssignRegion from "./pages/Procurement/RegionAllocation/AssignRegion";
import TrainingDetails from "./pages/Procurement/TrainingDetail/TrainingDetails";
import SalaryCalculation from "./pages/Employee/SalaryCalculation/SalaryCalculation";
import SalaryTemplate from "./pages/Employee/SalaryTemplate/SalaryTemplate";
import Attendance from "./pages/Employee/EmployeeAttendance/Attendance";
import EmployeeDetails from "./pages/Employee/EmployeeDetails/EmployeeDetails";
import TrainingAttendance from "./pages/Procurement/TrainingAttendance/TrainingAttendance";
import BroadCastMessage from "./pages/Procurement/Notification/BroadCastMessage";
import CustomerWiseSalesOrders from "./pages/MIS/Sales/CustomerWiseSalesOrders";
import TotalInvoices from "./pages/MIS/Sales/TotalInvoices";
import SalesReturnMis from "./pages/MIS/Sales/SalesReturn";
import CreditDebitNoteReport from "./pages/MIS/Sales/CreditDebitNoteReport";
import CustomersAns from "./pages/Analytics/Sales/Customers";
import SalesOrderAns from "./pages/Analytics/Sales/SalesOrder";
import SalesInvoiceAns from "./pages/Analytics/Sales/SalesInvoice";
import SalesDashboard from "./pages/Analytics/Sales/SalesDashboard";
import RevenueDashboard from "./pages/Analytics/Sales/RevenueDashboard";
import Customers from "./pages/SalesOperations/Customers/Customers";
import SalesOrder from "./pages/SalesOperations/SalesOrder/SalesOrder";
import SalesInvoice from "./pages/SalesOperations/SalesInvoice/SalesInvoice";
import SalesReturn from "./pages/SalesOperations/SalesReturn/SalesReturn";
import SalesReturnInvoice from "./pages/SalesOperations/SalesReturnInvoice/SalesReturnInvoice";
import CreditDebitNote from "./pages/SalesOperations/CreditDebitNote/CreditDebitNote";
import MarketSurvey from "./pages/SalesOperations/MarketSurvey/MarketSurvey";
import ProductRequest from "./pages/SalesOperations/ProductRequest/ProductRequest";
import VanStock from "./pages/SalesOperations/VanStock/VanStock";
import FarmerWiseMIS from "./pages/MIS/procurement/FarmerWiseMIS";
import ExecutiveWiseMIS from "./pages/MIS/procurement/ExecutiveWiseMIS";
import ComplianceProcureMIS from "./pages/MIS/procurement/ComplianceProcureMIS";
import RegionWiseProcureMIS from "./pages/MIS/procurement/RegionWiseProcureMIS";
import FarmerDetail from "./pages/MIS/procurement/FarmerMIS/FarmerDetail";
import FarmerDealReport from "./pages/MIS/procurement/FarmerMIS/FarmerDealReport";
import FarmerWiseProcurement from "./pages/MIS/procurement/FarmerMIS/FarmerWiseProcurement";
import FarmerInvoiceDetailReport from "./pages/MIS/procurement/FarmerMIS/FarmerInvoiceDetailReport";
import FarmerPaymentDetailReport from "./pages/MIS/procurement/FarmerMIS/FarmerPaymentDetailReport";
import CropObservationReport from "./pages/MIS/procurement/FarmerMIS/CropObservationReport";
import FarmerGoodsIssueReport from "./pages/MIS/procurement/FarmerMIS/FarmerGoodsIssueReport";
import FarmerMRLDetailReport from "./pages/MIS/procurement/FarmerMIS/FarmerMRLDetailReport";
import FarmerSoilDetailReport from "./pages/MIS/procurement/FarmerMIS/FarmerSoilDetailReport";
import FarmerWaterDetailReport from "./pages/MIS/procurement/FarmerMIS/FarmerWaterDetailReport";
import FarmerQualityCheckDetailReport from "./pages/MIS/procurement/FarmerMIS/FarmerQualityCheckDetailReport";
import YieldEstimationsDetailReport from "./pages/MIS/procurement/FarmerMIS/YieldEstimationsDetailReport";
import AssignSalesRegion from "./pages/Sales Management/RegionAllocation/AssignSalesRegion";
import SalesBroadCastMessage from "./pages/Sales Management/Notification/SalesBroadCastMessage";
import SalesTarget from "./pages/Sales Management/SalesTarget/SalesTarget";
import AgronomyRecommendation from "./pages/Procurement/AgronomyRecommendations/AgronomyRecommendation";
import AgronomyDetail from "./pages/Procurement/AgronomyDetail/AgronomyDetail";
import WarehouseStockInfo from "./pages/Procurement/WarehouseStockInfo/WarehouseStockInfo";
import ComplianceConfig from "./pages/master/complianceconfig/ComplianceConfig";
import ProcurementChart from "./pages/Analytics/Procurement/ProcurementChart";
import Dashboard from "./pages/Analytics/Procurement/dashboard";
import Farmer360Form from "./pages/Analytics/Procurement/Farmer360Form";
import Farmer360FMN from "./pages/Analytics/Procurement/Farmer360FMN";
import FarmerOneMapForm from "./pages/Analytics/Procurement/FarmerOneMapForm";
import HarvestDashboard from "./pages/Analytics/Procurement/HarvestDashboard";
import InternalInspcection from "./pages/Compliance/Commercial/Internal/InternalInspcection";
import GlobalGap from "./pages/Compliance/Commercial/GlobalGap/GlobalGap";
import FarmInspcection from "./pages/Compliance/Commercial/Farm/FarmInspcection";
import RiskAssessment from "./pages/Compliance/Commercial/Risk/RiskAssessment";
import ProInternalInspcection from "./pages/Compliance/Procurement/Internal/ProInternalInspcection";
import ProGlobalGap from "./pages/Compliance/Procurement/GlobalGap/ProGlobalGap";
import ProFarmInspcection from "./pages/Compliance/Procurement/Farm/ProFarmInspcection";
import ProRiskAssessment from "./pages/Compliance/Procurement/Risk/ProRiskAssessment";
import VendorSupplier from "./pages/Warehouse/VendorSupplier/VendorSupplier";
import PurchaseOrder from "./pages/Warehouse/Purchase&Return/PurchaseOrder/PurchaseOrder";
import GoodsReciept from "./pages/Warehouse/Purchase&Return/Goods Reciept/GoodsReciept";
import FieldActivityCalendarList from "./pages/CommercialManagement/FieldActivityCalendar/FieldActivityCalendarList";
import AgronomyCommercialRecommendation from "./pages/CommercialManagement/AgronomyRecommendations/AgronomyCommercialRecommendation";
import BudgetAllocation from "./pages/CommercialManagement/BudgetAllocation/BudgetAllocation";
import FieldActivityTask from "./pages/CommercialManagement/FieldActivityTask/FieldActivityTask";
import StandardMIS from "./pages/MIS/CommercialFarming/StandardMIS";
import FieldActivityDetailReport from "./pages/MIS/CommercialFarming/StandardReport/FieldActivityDetailReport";
import MRLDetailReport from "./pages/MIS/CommercialFarming/StandardReport/MRLDetailReport";
import LabourDetailReport from "./pages/MIS/CommercialFarming/StandardReport/LabourDetailReport";
import HarvestDetailReport from "./pages/MIS/CommercialFarming/StandardReport/HarvestDetailReport";
import MaturityIndicesDetailReport from "./pages/MIS/CommercialFarming/StandardReport/MaturityIndicesDetailReport";
import FieldActivityPlotwiseDetailReport from "./pages/MIS/CommercialFarming/StandardReport/FieldActivityPlotwiseDetailReport";
import FieldActivityCropwiseDetailReport from "./pages/MIS/CommercialFarming/StandardReport/FieldActivityCropwiseDetailReport";
import FieldActivityFarmManagerWiseReport from "./pages/MIS/CommercialFarming/StandardReport/FieldActivityFarmManagerWiseReport";
import FarmManagerwiseBudgetApprovalDetailReport from "./pages/MIS/CommercialFarming/StandardReport/FarmManagerwiseBudgetApprovalDetailReport";
import WaterObservationDetailReport from "./pages/MIS/CommercialFarming/StandardReport/WaterObservationDetailReport";
import SoilObservationDetailReport from "./pages/MIS/CommercialFarming/StandardReport/SoilObservationDetailReport";
import ProductwiseInputConsumptionDetailReport from "./pages/MIS/CommercialFarming/StandardReport/ProductwiseInputConsumptionDetailReport";
import MachineryDetailReport from "./pages/MIS/CommercialFarming/StandardReport/MachineryDetailReport";
import YieldEstimationsStdDetailReport from "./pages/MIS/CommercialFarming/StandardReport/YieldEstimationsStdDetailReport";
import UserStockDetailReport from "./pages/MIS/CommercialFarming/StandardReport/UserStockDetailReport";
import CommercialChart from "./pages/Analytics/Commercial/CommercialChart";
import SalesBeatPlan from "./pages/Sales Management/SalesBeatPlan/SalesBeatPlan";
import FieldOfficerTransfer from "./pages/Warehouse/GoodsTransfer/FieldOfficer/FieldOfficerTransfer";
import WarehouseTransfer from "./pages/Warehouse/GoodsTransfer/OtherWarehouse/WarehouseTransfer";
import VansaleGoodIssue from "./pages/Warehouse/GoodsTransfer/VanSalesGoodsIssue/VansaleGoodIssue";
import WorkServiceOrder from "./pages/Warehouse/WorkService/WorkServiceOrder/WorkServiceOrder";
import WorkServiceInvoice from "./pages/Warehouse/WorkService/WorkServiceInvoice/WorkServiceInvoice";
import FuelRefilling from "./pages/Warehouse/FuelRefill/FuelRefilling";
import GatePassIn from "./pages/Warehouse/GetPass/GatePassIn/GatePassIn";
import GatePassOut from "./pages/Warehouse/GetPass/GatePassOut/GatePassOut";
import DirectFarmerPayment from "./pages/Warehouse/Procurement/DirectFarmerPayment/DirectFarmerPayment";
import DirectFarmerInvoice from "./pages/Warehouse/Procurement/DirectFarmerInvoice/DirectFarmerInvoice";
import ProcurementReciept from "./pages/Warehouse/Procurement/Reciept/ProcurementReciept";
import VehicleRegistration from "./pages/Warehouse/Vehicle/VehicleRegistration/VehicleRegistration";
import RentedInvoice from "./pages/Warehouse/Vehicle/RentedInvoice/RentedInvoice";
import VehicleMaintenance from "./pages/Warehouse/Vehicle/Maintenance/VehicleMaintenance";
import DeliveryDispatchDr from "./pages/Warehouse/DeliveryDispatch/DeliveryDispatchDr/DeliveryDispatchDr";
//import DeliveryDispatchCLList from "./pages/Warehouse/DeliveryDispatch/DeliveryDispatchCL/DeliveryDispatchCLList";
import DeliveryDispatchCL from "./pages/Warehouse/DeliveryDispatch/DeliveryDispatchCL/DeliveryDispatchCL";
import Palletization from "./pages/Warehouse/Palletization/Palletization";
import ContainerLoading from "./pages/Warehouse/ContainerLoading/ContainerLoading";
//import PurchaseInvoiceForm from "./pages/Warehouse/Purchase&Return/PurchaseInvoice/PurchaseInvoiceForm";
import PurchaseInvoice from "./pages/Warehouse/Purchase&Return/PurchaseInvoice/PurchaseInvoice";
import ReturnReciept from "./pages/Warehouse/Purchase&Return/Goods Return Reciept/ReturnReciept";
import ReturnInvoice from "./pages/Warehouse/Purchase&Return/Goods Return Invoice/ReturnInvoice";
import AQC from "./pages/Warehouse/Quality Checks/Arrival Quality Check/AQC";
import PSI from "./pages/Warehouse/Quality Checks/Pre-Shipment Inspection/PSI";
import DPI from "./pages/Warehouse/Quality Checks/During Packhouse Inspection/DPI";
import CLS from "./pages/Warehouse/Quality Checks/Container Loading Supervision/CLS";
import SQC from "./pages/Warehouse/Quality Checks/Seed Quality Check/SQC";
import LotCreation from "./pages/Warehouse/Packhouse/Lot Creation/LotCreation";
import CleaningWashing from "./pages/Warehouse/Packhouse/Cleaning & Washing/CleaningWashing";
import SortingGarding from "./pages/Warehouse/Packhouse/SortingGarding/SortingGarding";
import PackingLabeling from "./pages/Warehouse/Packhouse/PackingLabling/PackingLabeling";
import OverallWarehouse from "./pages/Warehouse/StockInHand/OverallWarehouse/OverallWarehouse";
import WarehouseWiseStock from "./pages/Warehouse/StockInHand/WarehousewiseStock/WarehouseWiseStock";
import UserWiseStock from "./pages/Warehouse/StockInHand/UserwiseStock/UserWiseStock";
import PreCooling from "./pages/Warehouse/Pre-Cooling/PreCooling";
import GoodsDiscard from "./pages/Warehouse/GoodsDiscard/GoodsDiscard";
import OperationalWiseMIS from "./pages/MIS/Warehouse/OperationalWiseMIS";
import ProcurementWiseMIS from "./pages/MIS/Warehouse/ProcurementWiseMIS";
import PurchaseWiseMIS from "./pages/MIS/Warehouse/PurchaseWiseMIS";
import LotCreationReport from "./pages/MIS/Warehouse/Operational/LotCreationReport";
import CleaningWashingReport from "./pages/MIS/Warehouse/Operational/CleaningWashingReport";
import SortingGradingReport from "./pages/MIS/Warehouse/Operational/SortingGradingReport";
import PackagingLabellingReport from "./pages/MIS/Warehouse/Operational/PackagingLabellingReport";
import PalletDetailReport from "./pages/MIS/Warehouse/Operational/PalletDetailReport";
import GatepassDetailsReport from "./pages/MIS/Warehouse/Operational/GatepassDetailsReport";
import PrecoolingReport from "./pages/MIS/Warehouse/Operational/PrecoolingReport";
import DeliveryDispatchReport from "./pages/MIS/Warehouse/Operational/DeliveryDispatchReport";
import FuelingReport from "./pages/MIS/Warehouse/Operational/FuelingReport";
import ContainerLoadingReport from "./pages/MIS/Warehouse/Operational/ContainerLoadingReport";
import ControlledAtmosphereStorageDetailReport from "./pages/MIS/Warehouse/Operational/ControlledAtmosphereStorageDetailReport";
import DirectFarmerInvoiceReport from "./pages/MIS/Warehouse/Procurement/DirectFarmerInvoiceReport";
import DirectFarmerPaymentReport from "./pages/MIS/Warehouse/Procurement/DirectFarmerPaymentReport";
import ProcurementRecieptReport from "./pages/MIS/Warehouse/Procurement/ProcurementRecieptReport";
import PurchaseOrderReport from "./pages/MIS/Warehouse/Purchase/PurchaseOrderReport";
import GoodsReceiptDetailReport from "./pages/MIS/Warehouse/Purchase/GoodsReceiptDetailReport";
import PurchaseInvoiceReport from "./pages/MIS/Warehouse/Purchase/PurchaseInvoiceReport";
import GoodsReturnReport from "./pages/MIS/Warehouse/Purchase/GoodsReturnReport";
import GoodsReturnInvoiceReport from "./pages/MIS/Warehouse/Purchase/GoodsReturnInvoiceReport";
import WorkServicesReport from "./pages/MIS/Warehouse/Purchase/WorkServicesReport";
import WorkServicesInvoiceReport from "./pages/MIS/Warehouse/Purchase/WorkServicesInvoiceReport";
import WarehouseChart from "./pages/Analytics/Warehouse/WarehouseChart";
import SampleApproval from "./pages/Warehouse/Seed Process/SampleApproval/SampleApproval";
import TestingLabs from "./pages/Warehouse/Seed Process/TestingbyLabs/TestingLabs";
import AtmosphereStorage from "./pages/Warehouse/AtmosphereStorage/AtmosphereStorage";
import UserProfile from "./pages/Profiles/UserProfile";
import OrgProfile from "./pages/Profiles/OrgProfile";
import ForgotPassword from "./pages/Login/ForgotPassword";
import GatePassInPrint from "./pages/Warehouse/GetPass/GatePassIn/GatePassInPrint";
import VendorUpload from "./pages/Upload/VendorUpload";
import Terms from "./components/Terms";
import EmployeeUpload from "./pages/Upload/EmployeeUpload";
import CustomerUpload from "./pages/Upload/CustomerUpload";
import ProductUpload from "./pages/Upload/ProductUpload";
import FarmerUpload from "./pages/Upload/FarmerUpload";
import FarmerPlotUpload from "./pages/Upload/FarmerPlotUpload";
import ProformaInvoice from "./pages/Exim Documentation/Proforma Invoice/ProformaInvoice";
import CommercialInvoice from "./pages/Exim Documentation/Commercial Invoice/CommercialInvoice";
import PackingList from "./pages/Exim Documentation/Packing List/PackingList";
import BillOfExchange from "./pages/Exim Documentation/Bill of Exchange/BillOfExchange";
import LetterofInstruction from "./pages/Exim Documentation/Letter of Instruction/LetterOfInstruction";
import Error404 from "./components/Error404";
import GanttChart from "./pages/CommercialManagement/GanttChart";
import QrCodeView from "./pages/Warehouse/Packhouse/PackingLabling/QrCodeView";
import InventoryClosing from "./pages/Warehouse/Inventory Closing/InventoryClosing";
import PhysicalInventory from "./pages/Warehouse/Physical Inventory/PhysicalInventory";
import EmployeeExpense from "./pages/FinanceManagement/EmployeeExpense/EmployeeExpense";
import AutoApproval from "./pages/AdminConsole/Auto Approval/AutoApproval";
import AuditLog from "./pages/AdminConsole/Audit Log/AuditLog";
import AgingReport from "./pages/FinanceManagement/Employee Aging Report/EmployeeAgingReport";
import EmployeeAgingReport from "./pages/FinanceManagement/Employee Aging Report/EmployeeAgingReport";
import CustomerAgingReport from "./pages/FinanceManagement/Customer Aging Report/CustomerAgingReport";
import VendorAgingReport from "./pages/FinanceManagement/Vendor Aging Report/VendorAgingReport";
import FarmerAgingReport from "./pages/FinanceManagement/Farmer Aging Report/FarmerAgingReport";
import VoucherDetailPayment from "./pages/MIS/Finance/VoucherDetailPayment";
import VoucherPayment from "./pages/MIS/Finance/VoucherPayment";
import GeneralLedger from "./pages/MIS/Finance/GeneralLedger";
import VendorLedger from "./pages/MIS/Finance/VendorLedger";
import CustomerLedger from "./pages/MIS/Finance/CustomerLedger";
import Home from "./components/Home";
import FarmerProductwiseGoodsIssueReport from "./pages/MIS/procurement/FarmerMIS/FarmerProductwiseGoodsIssueReport";
import FarmerInputTemplate from "./pages/Procurement/FarmerInputTemplate/FarmerInputTemplate";
import AppPermissions from "./pages/AdminConsole/App Permissions/AppPermissions";
import LoanRequest from "./pages/Procurement/Loan Request/LoanRequest";
import SeasonDetails from "./pages/master/SeasonDetails/SeasonDetails";
import InsectDiseasePest from "./pages/master/Insect Disease Pest/InsectDiseasePest";
import NurseryGroup from "./pages/master/Nursery Group/NurseryGroup";
import NurseryReport from "./pages/MIS/procurement/FarmerMIS/NurseryReport";
import StationDetails from "./pages/master/Station Details/StationDetails";
import RegionDetails from "./pages/master/Region Details/RegionDetails";
import AreaDetails from "./pages/master/Area Details/AreaDetails";
import CountryDetails from "./pages/master/Country Details/CountryDetails";
import Designation from "./pages/master/Designation/Designation";
import MarketSurveyParameter from "./pages/master/Market Survey Parameter/MarketSurveyParameter";
import GradeDetails from "./pages/master/Grade Details/GradeDetails";
import FarmerCropCuringReport from "./pages/MIS/procurement/FarmerMIS/FarmerCropCuringReport";
import StationwiseTargets from "./pages/MIS/procurement/FarmerMIS/StationwiseTargets";
import AreawiseTargets from "./pages/MIS/procurement/FarmerMIS/AreawiseTargets";
import SalesRate from "./pages/master/SalesRate/SalesRate";
import DataViewPermesison from "./pages/Employee/DataViewPermesison/DataViewPermesison";
import FieldExecutiveChange from "./pages/Sales Management/FieldExecutiveChange/FieldExecutiveChange";
import EmployeeExpenseReport from "./pages/MIS/Finance/EmployeeExpenseReport";
import OrgPermissions from "./pages/AdminConsole/Org Permissions/OrgPermissions";
import FarmerTargetHarvestReport from "./pages/MIS/procurement/FarmerMIS/FarmerTargetHarvestReport";
import RateCardDetails from "./pages/master/Rate Card Details/RateCardDetails";
import TransferReceipt from "./pages/Warehouse/GoodsTransfer/TransferReceipt/TransferReceipt";
import FarmerPurchase from "./pages/Warehouse/Procurement/FarmerPurchase/FarmerPurchase";
import MarketDetails from "./pages/master/Market Details/MarketDetails";
import ServiceMaster from "./pages/System Admin/Org Configuration/Service Master/ServiceMaster";
import FarmerPurchaseListReport from "./pages/MIS/Warehouse/Procurement/FarmerPurchaseListReport";
import FarmerPurchaseDetailReport from "./pages/MIS/Warehouse/Procurement/FarmerPurchaseDetailReport";
import FarmerwiseProcurementDetails from "./pages/MIS/procurement/FarmerMIS/FarmerwiseProcurementDetails";
import TobaccoProcessing from "./pages/Warehouse/Packhouse/TobaccoProcessing/TobaccoProcessing";
import FarmerBankDetail from "./pages/MIS/procurement/FarmerMIS/FarmerBankDetails";
import FarmerCropSowingDetailReport from "./pages/MIS/procurement/FarmerMIS/FarmerCropSowingDetail";
import FarmerCropProductReport from "./pages/MIS/procurement/FarmerMIS/FarmerCropProductReport";
import FarmerScoreboardReport from "./pages/MIS/procurement/FarmerMIS/FarmerScoreboard";
import WeighbridgeReport from "./pages/MIS/procurement/FarmerMIS/WeighbridgeReport";
import FarmerComplianceReport from "./pages/MIS/procurement/FarmerMIS/FarmerCompliance";
import FarmerNLCReport from "./pages/MIS/procurement/FarmerMIS/FarmerNLCReport";
import VehicleBridgeHarvestDetailReport from "./pages/MIS/procurement/FarmerMIS/VehicleBridgeHarvestDetailReport";
import FarmerBudgetReport from "./pages/MIS/procurement/FarmerMIS/FarmerBudgetReport";
import Stock from "./pages/Upload/Stock/Stock";
import GoodsProductwiseIssuedReport from "./pages/MIS/Warehouse/Operational/GoodsProductwiseIssuedReport";
import FarmerBalance from "./pages/Upload/Farmer Balance/FarmerBalance";
import APkUpload from "./pages/AdminConsole/APKUpload/APkUpload";
import F1MAP from "./pages/Analytics/Procurement/F1MAP";
import OpeningStockReport from "./pages/MIS/Warehouse/Purchase/OpeningStockReport";
import FarmerOpeningBalanceReport from "./pages/MIS/Finance/FarmerOpeningBalanceReport";
import WarehouseAccess from "./pages/master/WarehouseAccess/WarehouseAccess";
import InventoryTransaction from "./pages/MIS/Warehouse/Operational/InventoryTransaction";
import FarmerDetails from "./pages/Procurement/FarmerDetails/FarmerDetails";
import FarmerSurveyTemplate from "./pages/master/Farmer Survey Template/FarmerSurveyTemplate";
import FarmersEnrollmentTemplate from "./pages/MIS/procurement/FMN/FarmersEnrollmentTemplate";
import PlotMapping from "./pages/MIS/procurement/FMN/PlotMapping";
import DistributionToMobileUser from "./pages/Procurement/DistributionToMobileUser/DistributionToMobileUser";
import FMNMIS from "./pages/MIS/procurement/FMNMIS";
import ProcurementTemplate from "./pages/Procurement/ProcurementTemplate/ProcurementTemplate";
import InputsDistributionFromMainWarehouseReport from "./pages/MIS/procurement/FMN/InputsDistributionFromMainWarehouseReport";
import WarehouseStockInfoReport from "./pages/MIS/procurement/FMN/WarehouseStockInfoReport";
import CropCutReport from "./pages/MIS/procurement/FMN/CropCutReport";
import ProcurementTemplateReport from "./pages/MIS/procurement/FMN/ProcurementTemplateReport";
import FarmerTrainingReport from "./pages/MIS/procurement/FMN/FarmerTrainingTemplate";
import RateCatalog from "./pages/master/RateCatalog/RateCatalog";
import GoodIssueDetail from "./pages/Procurement/goodIssueDetail/goodIssueDetail";
import FarmerCropCut from "./pages/Procurement/FarmerCropCut/FarmerCropCut";

import FarmerPlotMapping from "./pages/Procurement/FarmerPlotMapping/FarmerPlotMapping";

import FarmerInspection from "./pages/Procurement/FarmerInspection/FarmerInspection";
import AgentCall from "./pages/Procurement/AgentCall/AgentCall";
import FarmerInvoice from "./pages/Procurement/FarmerInvoice/FarmerInvoice";
import FarmerVehicleInvoiceReport from "./pages/MIS/procurement/FarmerMIS/FarmerVehicleInvoice";

import FarmerSurveyReport from "./pages/MIS/procurement/FMN/FarmerSurveyReport";
import AgentCallService from "./pages/MIS/procurement/FMN/AgentCallService";

import FarmerInspectionReport from "./pages/MIS/procurement/FMN/FarmerInspectionReport";

import EmployeeMis from "./pages/MIS/Administrator/EmployeeMis";
import EmployeeDetailsReport from "./pages/MIS/Administrator/Employee/EmployeeDetailsReport";
import DeviceLockUnlockReport from "./pages/MIS/Administrator/Employee/DeviceLockUnlockReport";

import FarmerGoodsIssueReportFMN from "./pages/MIS/procurement/FMN/FarmerGoodsIssueReportFMN";
import FarmerProductwiseGoodsIssueReportFMN from "./pages/MIS/procurement/FMN/FarmerProductwiseGoodsIssueReportFMN";
import FarmerUploadFMN from "./pages/Upload/FarmerUploadFMN";
import FarmerPlotUploadFMN from "./pages/Upload/FarmerPlotUploadFMN";
import MobileAppEnableDisable from "./pages/master/mobileAppEnableDisable/mobileAppEnableDisable";
import FarmerGoodsIssuedUploadFMN from "./pages/Upload/FarmerGoodsIssuedUploadFMN";

import State from "./pages/master/State/State";

import FarmerGoodsIssueProductReportFMN from "./pages/MIS/procurement/FMN/FarmerGoodsIssueProductReportFMN";
import LGADetail from "./pages/master/LGA/LGADetails";
import HubDetail from "./pages/master/Hub Detail/HubDetail";
import RanchDetail from "./pages/master/Ranch Details/RanchDetails";

import OrganizationConfigurations from "./pages/System Admin/Org Configuration/Organization Configurations/OrganizationConfigurations";
import ReportServiceFieldAllocation from "./pages/System Admin/Org Configuration/Report Service Field Allocation/ReportServiceFieldAllocate";
import OrgWiseDeviceLockUnlock from "./pages/System Admin/Org Configuration/Organization Wise Device Lock Unlock/OrgWiseDeviceLockUnlock";
import OrganizationWiseDashboardAllocation from "./pages/System Admin/Org Configuration/Organization Wise Dashboard Allocation/OrganizationWiseDashboardAllocation";

import SalesTrainingDetail from "./pages/AgriPromoter/SalesTrainingDetail/SalesTrainingDetail";

import AgriPromoterTarget from "./pages/AgriPromoter/AgriPromoter Target/AgriPromoterTarget";

// import FarmerBudgetReport from "./pages/MIS/procurement/FarmerMIS/FarmerBudget";
import AgriMIS from "./pages/MIS/AgriPromoter/AgriMIS";
import AgriPromoter from "./pages/MIS/AgriPromoter/AgriPromoterMIS/AgriPromoter";
import FieldDaysIndicator from "./pages/MIS/AgriPromoter/AgriPromoterMIS/FieldDaysIndicator";
import FieldDaysAttendance from "./pages/MIS/AgriPromoter/AgriPromoterMIS/FieldDaysAttendance";
import HubStockInfo from "./pages/AgriPromoter/HubStockInfo/HubStockInfo";
import TrainingMOV from "./pages/MIS/AgriPromoter/AgriPromoterMIS/TrainingMOV";
import TrainingKPI from "./pages/MIS/AgriPromoter/AgriPromoterMIS/TrainingKPI";
import MarketIntelligenceGathering from "./pages/MIS/AgriPromoter/AgriPromoterMIS/MarketIntelligenceGathering";
import FieldDemonstrationTarget from "./pages/MIS/AgriPromoter/AgriPromoterMIS/FieldDemonstrationTarget";
import SalesKPI from "./pages/MIS/AgriPromoter/AgriPromoterMIS/SalesKPI";

import HubStock from "./pages/Warehouse/StockInHand/HubStock/HubStock";
import FieldIndicatorDetails from "./pages/MIS/AgriPromoter/AgriPromoterMIS/FieldIndicatorDetails";
import MarketIntelligenceCrop from "./pages/MIS/AgriPromoter/AgriPromoterMIS/MarketIntelligenceCrop";
import ProductSales from "./pages/MIS/AgriPromoter/AgriPromoterMIS/ProductSales";
import AgriPromoterDashborad from "./pages/Dashboard/AgriPromoterDashborad";
import NurseryDetail from "./pages/master/Nursery Detail/NurseryDetail";
import ProcurementAnalytics from "./pages/Analytics/Procurement/ProcurementAnalytics";
import MediaRegistration from "./pages/Nursery/Media Registration/MediaRegistration";
import NurseryStock from "./pages/Nursery/NursaryStock/NurseryStock";

import AgriFarmersEnrollmentTemplate from "./pages/MIS/AgriPromoter/AgriPromoterMIS/AgriFarmersEnrollmentTemplate";
import AgriFarmerInspectionReport from "./pages/MIS/AgriPromoter/AgriPromoterMIS/AgriFarmerInspection";
import AgriCropCutReport from "./pages/MIS/AgriPromoter/AgriPromoterMIS/AgriCropCut";
import HubSalesReport from "./pages/MIS/AgriPromoter/AgriPromoterMIS/HubSales";
import FarmerTotalHarvestDynamicReport from "./pages/MIS/procurement/FarmerMIS/farmerTotalHarvestReport";
import FarmerTotalHarvestSummaryReport from "./pages/MIS/procurement/FarmerMIS/totalHarvestSummaryReport";
import BudgetTemplate from "./pages/Procurement/FarmerBudgetTemplate/BudgetTemplate";
import HubInventorySummary from "./pages/MIS/AgriPromoter/AgriPromoterMIS/HubInventorySummary";
import HubstockToMobileUser from "./pages/AgriPromoter/HubstockToMobileUser/HubstockToMobileUser";
import MaizeFSDataCaptureReport from "./pages/MIS/procurement/FMN/MaizeFSDataCapture";
import RegionWiseDashboard from "./pages/MIS/procurement/FarmerMIS/RegionWiseDashboard";
import DemoFertilizerTrial from "./pages/MIS/procurement/FMN/DemoFertilizerTrial";
import DemoFertilizerTrialReport from "./pages/MIS/procurement/FMN/DemoFertilizerTrial";
import DrySeasonFertilizerReprot from "./pages/MIS/procurement/FarmerMIS/DrySeasonFertilizerReprot";
import FarmerSummaryReport from "./pages/MIS/procurement/FarmerMIS/TomatoJoe/FarmerSummaryReport";
import BrazilHybridMaizeReport from "./pages/MIS/procurement/FMN/BrazilHybridMaizeReport";
import MaizeandSorghumTRIALSReport from "./pages/MIS/procurement/FMN/MaizeandSorghumTRIALSReport";
import PlotMappingTjoe from "./pages/MIS/procurement/FarmerMIS/TomatoJoe/PlotMappingTjoe";
import DirectStockReceipt from "./pages/Warehouse/Purchase&Return/DirectStockReceipt/DirectStockReceipt";
import HarvestDetails from "./pages/Procurement/HarvestDetails/HarvestDetails";
import DirectGoodsReceiptReport from "./pages/MIS/Warehouse/Purchase/DirectGoodsReceiptReport";
import OperationsReports from "./pages/MIS/Nursery/OperationsReports/OperationsReports";
import MotherPlant from "./pages/MIS/Nursery/OperationsReports/MotherPlant";
import Login360 from "./pages/360View/360Login/Login";
import ForgotPassword360 from "./pages/360View/360Login/ForgotPassword";
// import NurseryTransfer from "./pages/MIS/Nursery/OperationsReports/nurseryTransfer";
import LabourDetails from "./pages/MIS/Nursery/OperationsReports/LabourDetails";
import NurseryObservationReport from "./pages/MIS/Nursery/OperationsReports/NurseryObservationReport";
import NurserySowingInputReport from "./pages/MIS/Nursery/OperationsReports/NurserySowingInputReport";
import NurserySowingOutputReport from "./pages/MIS/Nursery/OperationsReports/NurserySowingOutputReport";
import FarmerNLCMaize from "./pages/MIS/procurement/FarmerMIS/FarmerNLCMaize";
import FarmerComplianceMaize from "./pages/MIS/procurement/FarmerMIS/farmerComplianceMaize";
import FarmerComprehensiveDataReport from "./pages/MIS/procurement/FarmerMIS/farmerComprehensiveDataReport";
import SeedMIS from "./pages/MIS/procurement/SeedMIS";
import ResearchProgramMIS from "./pages/MIS/procurement/ResearchProgramMIS";
import FarmerSeason from "./pages/Procurement/FarmerSeason/FarmerSeason";
import FmanBankDetails from "./pages/MIS/procurement/FMN/FmanBankDetails";
import CropSowingReport from "./pages/MIS/procurement/FMN/CropSowingReport";
import NurseryTransfer from "./pages/MIS/Nursery/OperationsReports/nurseryTransfer";
import FarmerSummaryDetailReport from "./pages/MIS/procurement/FarmerMIS/TomatoJoe/FarmerSummaryDetailReport";

const router = createBrowserRouter([
  {
    path: "/auth",
    element: <Login />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },

  {
    path: "/packdetail/:orgId/:plmId",
    element: <QrCodeView />,
  },
  {
    path: "/360Login",
    element: <Login360 />,
  },
  {
    path: "/360ForgotPassword",
    element: <ForgotPassword360 />,
  },
  {
    path: "*",
    element: <Error404 />,
  },

  {
    path: "/",
    element: <GuardRouter />,
    children: [
      //systemAdmin

      {
        path: "/serviceMaster",
        element: <ServiceMaster />,
      },
      {
        path: "/organizationConfigurations",
        element: <OrganizationConfigurations />,
      },
      {
        path: "/organizationWiseDashboardAllocation",
        element: <OrganizationWiseDashboardAllocation />,
      },
      {
        path: "/reportServiceFieldAllocation",
        element: <ReportServiceFieldAllocation />,
      },
      {
        path: "/orgWiseDeviceLockUnlock",
        element: <OrgWiseDeviceLockUnlock />,
      },

      // adminconsole
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/terms",
        element: <Terms />,
      },
      {
        path: "/user",
        element: <Users />,
      },

      {
        path: "/roles",
        element: <Roles />,
      },
      {
        path: "/billing",
        element: <Billing />,
      },
      {
        path: "/support",
        element: <Support />,
      },
      {
        path: "/settings",
        element: <Settings />,
      },
      {
        path: "/autoApproval",
        element: <AutoApproval />,
      },
      {
        path: "/auditLog",
        element: <AuditLog />,
      },
      {
        path: "/appPermissions",
        element: <AppPermissions />,
      },
      {
        path: "/orgPermissions",
        element: <OrgPermissions />,
      },
      {
        path: "/APKUpload",
        element: <APkUpload />,
      },

      //employee
      {
        path: "/employee",
        element: <EmployeeDetails />,
      },
      {
        path: "/dataViewPermissions",
        element: <DataViewPermesison />,
      },

      { path: "/employeeAttendance", element: <Attendance /> },
      { path: "/salaryTemplate", element: <SalaryTemplate /> },
      { path: "/salaryCalculation", element: <SalaryCalculation /> },

      //master
      { path: "/variety", element: <Variety /> },

      { path: "/collectioncenter", element: <CollectionCenters /> },
      { path: "/unit", element: <Unit /> },
      { path: "/tax", element: <Tax /> },
      { path: "/ratecard", element: <RateCard /> },
      { path: "/mrpcard", element: <MRPRateCard /> },
      {
        path: "/rateCatalog",
        element: <RateCatalog />,
      },
      { path: "/mrl", element: <MRL /> },

      { path: "/product", element: <Product /> },

      { path: "/complianceconfig", element: <ComplianceConfig /> },

      {
        path: "/mrltemplate",
        element: <MRPRateCard />,
      },
      {
        path: "/holiday",
        element: <Holidays />,
      },
      {
        path: "/financialYear",
        element: <FinancialYear />,
      },
      {
        path: "/warehouse",
        element: <Warehouse />,
      },
      {
        path: "/nurseryDetail",
        element: <NurseryDetail />,
      },
      {
        path: "/designation",
        element: <Designation />,
      },
      {
        path: "/department",
        element: <Department />,
      },
      {
        path: "/farmersurveytemplate",
        element: <FarmerSurveyTemplate />,
      },
      {
        path: "/marketsurveyparameter",
        element: <MarketSurveyParameter />,
      },
      {
        path: "/qualitycheckparameter",
        element: <QualityCheckParameter />,
      },
      {
        path: "/leave",
        element: <LeaveTemplate />,
      },

      {
        path: "/salaryhead",
        element: <SalaryHead />,
      },
      {
        path: "/seasonDetails",
        element: <SeasonDetails />,
      },
      {
        path: "/insectDiseasePest",
        element: <InsectDiseasePest />,
      },
      {
        path: "/nurseryGroup",
        element: <NurseryGroup />,
      },

      {
        path: "/stationDetails",
        element: <StationDetails />,
      },
      {
        path: "/regionDetails",
        element: <RegionDetails />,
      },
      {
        path: "/areaDetails",
        element: <AreaDetails />,
      },
      {
        path: "/countryDetails",
        element: <CountryDetails />,
      },
      {
        path: "/gradeDetails",
        element: <GradeDetails />,
      },
      {
        path: "/salesRateCard",
        element: <SalesRate />,
      },
      {
        path: "/mobileAppEditEnableDisable",
        element: <MobileAppEnableDisable />,
      },

      {
        path: "/rateCardDetails",
        element: <RateCardDetails />,
      },
      {
        path: "/marketDetails",
        element: <MarketDetails />,
      },

      {
        path: "/stockUpload",
        element: <Stock />,
      },
      {
        path: "/farmerBalance",
        element: <FarmerBalance />,
      },
      {
        path: "/warehouseAccess",
        element: <WarehouseAccess />,
      },

      {
        path: "/rateCatalog",
        element: <RateCatalog />,
      },
      {
        path: "/state",
        element: <State />,
      },
      {
        path: "/lga",
        element: <LGADetail />,
      },
      {
        path: "/hubDetail",
        element: <HubDetail />,
      },
      {
        path: "/ranchDetail",
        element: <RanchDetail />,
      },

      //employee mis
      {
        path: "/employeeMis",
        element: <EmployeeMis />,
      },
      {
        path: "/employeeDetailsReport",
        element: <EmployeeDetailsReport />,
      },
      {
        path: "/employeeDetailsReport",
        element: <DeviceLockUnlockReport />,
      },

      //procurement console

      {
        path: "/beatplan",
        element: <BeatPlan />,
      },
      {
        path: "/procurementtarget",
        element: <ProcurementTarget />,
      },

      {
        path: "/discountapproval",
        element: <DiscountApproval />,
      },

      {
        path: "/regionallocation",
        element: <AssignRegion />,
      },

      {
        path: "/agronomyrecommendations",
        element: <AgronomyRecommendation />,
      },
  
      {
        path: "/agronomydetail",
        element: <AgronomyDetail />,
      },

      {
        path: "/warehousestockinfo",
        element: <WarehouseStockInfo />,
      },
      {
        path: "/farmercropcut",
        element: <FarmerCropCut />,
      },
      {
        path: "/maizeDataCaptureReport",
        element: <MaizeFSDataCaptureReport />,
      },
      {
        path: "/DemoFertilizerTrialReport",
        element: <DemoFertilizerTrialReport />,
      },
      {
        path: "/DrySeasonFertilizerReprot",
        element: <DrySeasonFertilizerReprot />,
      },
      {
        path: "/BrazilHybridMaizeReport",
        element: <BrazilHybridMaizeReport />,
      },
      {
        path: "/MaizeandSorghumTRIALSReport",
        element: <MaizeandSorghumTRIALSReport />,
      },
      {
        path: "/regionWiseDashboard",
        element: <RegionWiseDashboard />,
      },
      {
        path: "/farmerinspection",
        element: <FarmerInspection />,
      },

      {
        path: "/messagebroadcast",
        element: <BroadCastMessage />,
      },

      { path: "/trainingdetail", element: <TrainingDetails /> },
      { path: "/trainingattendance", element: <TrainingAttendance /> },
      { path: "/farmerinputtemplate", element: <FarmerInputTemplate /> },

      {
        path: "/loanRequest",
        element: <LoanRequest />,
      },
      {
        path: "/farmerEnrolment",
        element: <FarmerDetails />,
      },
      {
        path: "/distributionToMobileUser",
        element: <DistributionToMobileUser />,
      },
      {
        path: "/procurementTemplate",
        element: <ProcurementTemplate />,
      },
      {
        path: "/procurementReport",
        element: <ProcurementTemplateReport />,
      },
      {
        path: "/farmerTrainingReport",
        element: <FarmerTrainingReport />,
      },
      {
        path: "/goodIssueDetail",
        element: <GoodIssueDetail />,
      },
      {
        path: "/farmerinspectionreport",
        element: <FarmerInspectionReport />,
      },
      {
        path: "/farmerSurveyReport",
        element: <FarmerSurveyReport />,
      },
      {
        path: "/agentCallService",
        element: <AgentCallService />,
      },

      {
        path: "/farmerPlotMapping",
        element: <FarmerPlotMapping />,
      },
      {
        path: "/agentCall",
        element: <AgentCall />,
      },
      {
        path: "/farmerInvoiceService",
        element: <FarmerInvoice />,
      },

      { path: "/salestraninigdetail", element: <SalesTrainingDetail /> },
      {
        path: "/farmerBudgetTemplate",
        element: <BudgetTemplate />,
      },

      {
        path: "/harvestDetails",
        element: <HarvestDetails />,
      },
      {
        path: "/farmerSeason",
        element: <FarmerSeason />,
      },

      //finance

      {
        path: "/accountgroup",
        element: <AccountGroup />,
      },
      {
        path: "/accountsubgroup",
        element: <AccountSubgroup />,
      },
      {
        path: "/bank",
        element: <Bank />,
      },
      {
        path: "/accountDetail",
        element: <AccountDetail />,
      },

      {
        path: "/accountMapping",
        element: <AccountMapping />,
      },
      {
        path: "/accounttransconfig",
        element: <AccountTransactionConfigurationList />,
      },
      { path: "/voucher", element: <Voucher /> },
      { path: "/employeeExpense", element: <EmployeeExpense /> },
      { path: "/employeeAgingReport", element: <EmployeeAgingReport /> },
      { path: "/customerAgingReport", element: <CustomerAgingReport /> },
      { path: "/vendorAgingReport", element: <VendorAgingReport /> },
      { path: "/farmerAgingReport", element: <FarmerAgingReport /> },

      //procurement mis

      { path: "/plotMapping", element: <PlotMapping /> },
      { path: "/plotMappingTjoe", element: <PlotMappingTjoe /> },
      {
        path: "/farmersEnrollmentTemplate",
        element: <FarmersEnrollmentTemplate />,
      },
      {
        path: "/farmercropsowingdetail",
        element: <FarmerCropSowingDetailReport />,
      },

           {
        path: "/fmancropsowingdetail",
        element: <CropSowingReport />,
      },
      {
        path: "/farmercropproductdetail",
        element: <FarmerCropProductReport />,
      },
      { path: "/farmerBankDetailreport", element: <FarmerBankDetail /> },

      { path: "/fmanBankDetailreport", element: <FmanBankDetails /> },
      { path: "/farmerwise", element: <FarmerWiseMIS /> },
      { path: "/executivewiseprocure", element: <ExecutiveWiseMIS /> },
      { path: "/regionwiseprocure", element: <RegionWiseProcureMIS /> },
      { path: "/procurecompliance", element: <ComplianceProcureMIS /> },
      { path: "/farmerreport", element: <FarmerDetail /> },
      {
        path: "/inputsdistributionfromwarehousereport",
        element: <InputsDistributionFromMainWarehouseReport />,
      },
      { path: "/farmerScoreboardReport", element: <FarmerScoreboardReport /> },
      { path: "/vehicleWeighBridgeReport", element: <WeighbridgeReport /> },
      { path: "/farmerComplianceReport", element: <FarmerComplianceReport /> },
      { path: "/farmerNlcReport", element: <FarmerNLCReport /> },

      { path: "/farmerComploanceMaize", element: <FarmerComplianceMaize /> },
      { path: "/farmerNLCMaize", element: <FarmerNLCMaize /> },
      {
        path: "/VehicleBridgeHarvestDetailReport",
        element: <VehicleBridgeHarvestDetailReport />,
      },
      {
        path: "/farmertotalharvestreport",
        element: <FarmerTotalHarvestDynamicReport />,
      },
      {
        path: "/totalHarvestSummaryReport",
        element: <FarmerTotalHarvestSummaryReport />,
      },
      { path: "/farmerBudgetReport", element: <FarmerBudgetReport /> },
      {
        path: "/farmerSummaryDetailReport",
        element: <FarmerSummaryDetailReport />,
      },
      { path: "/farmerSummaryReport", element: <FarmerSummaryReport /> },

      {
        path: "/farmerTargetHarvestReport",
        element: <FarmerTargetHarvestReport />,
      },

      { path: "/farmerdealreport", element: <FarmerDealReport /> },
      { path: "/farmerwiseprocurement", element: <FarmerWiseProcurement /> },

      {
        path: "/farmerwiseprocurementdetails",
        element: <FarmerwiseProcurementDetails />,
      },
      { path: "/farmerinvoicedetail", element: <FarmerInvoiceDetailReport /> },
      { path: "/farmerpaymentdetail", element: <FarmerPaymentDetailReport /> },
      { path: "/farmergoodsissuedetail", element: <FarmerGoodsIssueReport /> },
      { path: "/farmercropobservation", element: <CropObservationReport /> },
      { path: "/farmercropCuring", element: <FarmerCropCuringReport /> },
      {
        path: "/farmergoodsissuefmndetail",
        element: <FarmerGoodsIssueReportFMN />,
      },

      {
        path: "/farmerproductwisegoodsissuedetail",
        element: <FarmerProductwiseGoodsIssueReport />,
      },
      {
        path: "/farmerproductwisegoodsissuedetailfmn",
        element: <FarmerProductwiseGoodsIssueReportFMN />,
      },

      {
        path: "/farmerGoodsIssueProductReportFMN",
        element: <FarmerGoodsIssueProductReportFMN />,
      },

      {
        path: "/Nursery",
        // element: <Nursery />,
      },

      { path: "/nurseryreport", element: <NurseryReport /> },

      {
        path: "/yieldestimationsdetail",
        element: <YieldEstimationsDetailReport />,
      },
      {
        path: "/qualitycheckdetail",
        element: <FarmerQualityCheckDetailReport />,
      },

      { path: "/farmermrldetailreport", element: <FarmerMRLDetailReport /> },
      { path: "/farmersoildetailreport", element: <FarmerSoilDetailReport /> },
      {
        path: "/farmerwaterdetailreport",
        element: <FarmerWaterDetailReport />,
      },
      {
        path: "/stationwiseTargets",
        element: <StationwiseTargets />,
      },
      {
        path: "/areawiseTargets",
        element: <AreawiseTargets />,
      },

      {
        path: "/fmnmis",
        element: <FMNMIS />,
      },

      {
        path: "/SeedMIS",
        element: <SeedMIS />,
      },
      {
        path: "/researchProgramMIS",
        element: <ResearchProgramMIS />,
      },

      ////agri promoter url
      {
        path: "/agrimis",
        element: <AgriMIS />,
      },
      {
        path: "/agriFarmersEnrollmentTemplate",
        element: <AgriFarmersEnrollmentTemplate />,
      },

      {
        path: "/agriPromoterReport",
        element: <AgriPromoter />,
      },
      {
        path: "/fieldDaysIndicator",
        element: <FieldDaysIndicator />,
      },
      {
        path: "/fieldDaysAttendance",
        element: <FieldDaysAttendance />,
      },
      {
        path: "/trainingMOV",
        element: <TrainingMOV />,
      },
      {
        path: "/trainingKPI",
        element: <TrainingKPI />,
      },
      {
        path: "/marketIntelligenceGatheringReport",
        element: <MarketIntelligenceGathering />,
      },
      {
        path: "/fieldDemonstrationTargetReport",
        element: <FieldDemonstrationTarget />,
      },
      {
        path: "/salesKPI",
        element: <SalesKPI />,
      },
      {
        path: "/fieldIndicatorDetails",
        element: <FieldIndicatorDetails />,
      },
      {
        path: "/marketIntelligenceCorpReport",
        element: <MarketIntelligenceCrop />,
      },
      {
        path: "/agriPoromoterProductSales",
        element: <ProductSales />,
      },

      {
        path: "/warehousestockinforeport",
        element: <WarehouseStockInfoReport />,
      },
      {
        path: "/cropcutreport",
        element: <CropCutReport />,
      },
      {
        path: "/hubinventorysummary",
        element: <HubInventorySummary />,
      },

      { path: "/procurementchart", element: <ProcurementChart /> },
      { path: "/dashboard", element: <Dashboard /> },
      { path: "/agriDashboard", element: <Dashboard /> },

      { path: "/procurementAnalytics", element: <ProcurementAnalytics /> },

      { path: "/farmer360", element: <Farmer360Form /> },
      { path: "/farmer360FMN", element: <Farmer360FMN /> },
      { path: "/fonemap", element: <FarmerOneMapForm /> },
      { path: "/harvestDashboard", element: <HarvestDashboard /> },

      { path: "/f1map", element: <F1MAP /> },

      // Commercial urls Start

      {
        path: "/fieldactivitycalendar",
        element: <FieldActivityCalendarList />,
      },
      { path: "/budgetallocation", element: <BudgetAllocation /> },
      {
        path: "/agronomycommercial",
        element: <AgronomyCommercialRecommendation />,
      },
      { path: "/fieldactivitytask", element: <FieldActivityTask /> },
      { path: "/standardreport", element: <StandardMIS /> },
      {
        path: "/fieldactivitydetailreport",
        element: <FieldActivityDetailReport />,
      },
      { path: "/mrldetailreport", element: <MRLDetailReport /> },
      { path: "/labourdetailreport", element: <LabourDetailReport /> },
      { path: "/harvestdetailreport", element: <HarvestDetailReport /> },
      {
        path: "/maturityindicesdetailreport",
        element: <MaturityIndicesDetailReport />,
      },
      {
        path: "/fieldactivityplotwisedetailreport",
        element: <FieldActivityPlotwiseDetailReport />,
      },
      {
        path: "/fieldactivitycropwisedetail",
        element: <FieldActivityCropwiseDetailReport />,
      },
      {
        path: "/fieldactivityfarmmanagerwisereport",
        element: <FieldActivityFarmManagerWiseReport />,
      },
      {
        path: "/farmmanagerwisebudgetapprovaldetailreport",
        element: <FarmManagerwiseBudgetApprovalDetailReport />,
      },

      {
        path: "productwiseinputconsumptiondetailreport",
        element: <ProductwiseInputConsumptionDetailReport />,
      },
      { path: "machinerydetailreport", element: <MachineryDetailReport /> },
      {
        path: "yieldestimationsstddetailreport",
        element: <YieldEstimationsStdDetailReport />,
      },
      {
        path: "soilobservationdetailreport",
        element: <SoilObservationDetailReport />,
      },
      {
        path: "waterobservationdetailreport",
        element: <WaterObservationDetailReport />,
      },

      { path: "userstockdetailreport", element: <UserStockDetailReport /> },

      { path: "commercialfarmdashboard", element: <CommercialChart /> },

      // Commercial urls End

      //exim docs

      { element: <ProformaInvoice />, path: "/proformaInvoice" },
      { element: <LetterofInstruction />, path: "/letterofInstruction" },
      { element: <CommercialInvoice />, path: "/commercialInvoice" },
      { element: <PackingList />, path: "/packingList" },
      { element: <BillOfExchange />, path: "/billOfExchange" },

      //sales operation

      { element: <CustomerWiseSalesOrders />, path: "/misCustSalesOrder" },
      { element: <TotalInvoices />, path: "/misTotalInvoice" },
      { element: <SalesReturnMis />, path: "/misSalesReturn" },
      { element: <CreditDebitNoteReport />, path: "/misCDNote" },
      { element: <SalesDashboard />, path: "/SalesDashboard" },
      { element: <RevenueDashboard />, path: "/salesrevenuekpi" },

      { element: <CustomersAns />, path: "/anaCustomers" },
      { element: <SalesOrderAns />, path: "/ansSalesOrder" },
      { element: <SalesInvoiceAns />, path: "/ansSalesInvoice" },

      { element: <Customers />, path: "/customers" },
      { element: <SalesOrder />, path: "/salesOrder" },
      { element: <SalesInvoice />, path: "/salesInvoice" },
      { element: <SalesReturn />, path: "/salesReturn" },
      { element: <SalesReturnInvoice />, path: "/salesReturnInvoice" },
      { element: <CreditDebitNote />, path: "/cdNote" },
      { element: <MarketSurvey />, path: "/marketSurvey" },
      { element: <ProductRequest />, path: "/productRequest" },
      { element: <VanStock />, path: "/vanStock" },

      //sales management
      { element: <AssignSalesRegion />, path: "/salesRegion" },
      { element: <SalesTarget />, path: "/salesTarget" },
      { element: <SalesBroadCastMessage />, path: "/salesNotification" },
      { element: <FieldExecutiveChange />, path: "/fieldExecutiveChange" },
      { element: <AgriPromoterDashborad />, path: "/agriPromoterDashborad" },

      //sales compliance
      { element: <GlobalGap />, path: "/globalGap" },
      { element: <InternalInspcection />, path: "/internalInspcection" },
      { element: <FarmInspcection />, path: "/farmInspcection" },
      { element: <RiskAssessment />, path: "/riskAssessment" },
      { element: <ProGlobalGap />, path: "/ProGlobalGap" },
      { element: <ProInternalInspcection />, path: "/ProInternalInspcection" },
      { element: <ProFarmInspcection />, path: "/ProFarmInspcection" },
      { element: <ProRiskAssessment />, path: "/ProRiskAssessment" },

      // warehouse operations

      { element: <VendorSupplier />, path: "/vendor" },
      { element: <PurchaseOrder />, path: "/purchaseOrder" },
      { element: <GoodsReciept />, path: "/goodsReciept" },
      { element: <PurchaseInvoice />, path: "/purchaseInvoice" },
      { element: <ReturnReciept />, path: "/goodsReturn" },
      {
        element: <ReturnInvoice />,
        path: "/goodsReturnInvoice",
      },
      {
        element: <DirectStockReceipt />,
        path: "/directStockReceipt",
      },

      { element: <FieldOfficerTransfer />, path: "/gtOfficer" },
      { element: <WarehouseTransfer />, path: "/gtow" },
      { element: <VansaleGoodIssue />, path: "/gtVanSale" },
      { element: <WorkServiceOrder />, path: "/workOrder" },
      { element: <WorkServiceInvoice />, path: "/workInvoice" },
      { element: <FuelRefilling />, path: "/fuelRefilling" },
      { element: <GatePassIn />, path: "/gatePassIn" },
      { element: <GatePassOut />, path: "/gatePassOut" },
      { element: <ProcurementReciept />, path: "/procurementReciept" },
      { element: <DirectFarmerInvoice />, path: "/farmerInvoice" },
      {
        element: <FarmerVehicleInvoiceReport />,
        path: "/farmerVehicleInvoiceReport",
      },
      { element: <DirectFarmerPayment />, path: "/farmerPayment" },
      { element: <VehicleRegistration />, path: "/registration" },
      { element: <RentedInvoice />, path: "/rentedInvoice" },
      { element: <VehicleMaintenance />, path: "/vehicleMaintenance" },
      { element: <DeliveryDispatchDr />, path: "/deliveryDispatch" },
      { element: <DeliveryDispatchCL />, path: "/ddContainer" },
      { element: <Palletization />, path: "/palletization" },
      { element: <ContainerLoading />, path: "/containerLoading" },
      { element: <GoodsDiscard />, path: "/goodsDiscard" },
      { element: <TransferReceipt />, path: "/transferReceipt" },

      //warehouse mis

      { path: "/purchasewise", element: <PurchaseWiseMIS /> },
      { path: "/procurementwise", element: <ProcurementWiseMIS /> },
      { path: "/operationalwise", element: <OperationalWiseMIS /> },

      { path: "/lotcreationreport", element: <LotCreationReport /> },
      { path: "/cleaningwashingreport", element: <CleaningWashingReport /> },

      { path: "/sortinggradingreport", element: <SortingGradingReport /> },
      {
        path: "/packaginglabellingreport",
        element: <PackagingLabellingReport />,
      },
      { path: "/palletdetailreport", element: <PalletDetailReport /> },
      { path: "/gatepassdetailreport", element: <GatepassDetailsReport /> },
      { path: "/precoolingdetailreport", element: <PrecoolingReport /> },
      { path: "/deliverydispatchreport", element: <DeliveryDispatchReport /> },
      { path: "/fueldetailreport", element: <FuelingReport /> },
      {
        path: "/controlledatmospherereport",
        element: <ControlledAtmosphereStorageDetailReport />,
      },
      { path: "/containerloadingreport", element: <ContainerLoadingReport /> },

      {
        path: "/directfarmerinvoicereport",
        element: <DirectFarmerInvoiceReport />,
      },
      {
        path: "/directfarmerpaymentreport",
        element: <DirectFarmerPaymentReport />,
      },
      {
        path: "/procurementrecieptreport",
        element: <ProcurementRecieptReport />,
      },

      {
        path: "/farmerpurchasereport",
        element: <FarmerPurchaseListReport />,
      },

      {
        path: "/farmerpurchaseDetailreport",
        element: <FarmerPurchaseDetailReport />,
      },

      { path: "/purchaseorderreport", element: <PurchaseOrderReport /> },

      {
        path: "/directGoodsReceiptReport",
        element: <DirectGoodsReceiptReport />,
      },
      {
        path: "/goodsreceiptdetailreport",
        element: <GoodsReceiptDetailReport />,
      },
      { path: "/purchaseinvoicereport", element: <PurchaseInvoiceReport /> },
      { path: "/goodsreturnreport", element: <GoodsReturnReport /> },
      {
        path: "/goodsreturninvoicereport",
        element: <GoodsReturnInvoiceReport />,
      },
      { path: "/workservicesreport", element: <WorkServicesReport /> },
      {
        path: "/workservicesinvoicereport",
        element: <WorkServicesInvoiceReport />,
      },

      { path: "/warehouseChart", element: <WarehouseChart /> },

      { path: "/farmerPurchase", element: <FarmerPurchase /> },

      { path: "/goodsProductIssue", element: <GoodsProductwiseIssuedReport /> },

      { path: "/openingStockReport", element: <OpeningStockReport /> },

      { path: "/inventoryTransaction", element: <InventoryTransaction /> },

      // warehouse urls End
      { element: <FieldOfficerTransfer />, path: "/gtOfficer" },
      { element: <WarehouseTransfer />, path: "/gtow" },
      { element: <VansaleGoodIssue />, path: "/gtVanSale" },
      { element: <WorkServiceOrder />, path: "/workOrder" },
      { element: <WorkServiceInvoice />, path: "/workInvoice" },
      { element: <FuelRefilling />, path: "/fuelRefilling" },
      { element: <GatePassIn />, path: "/gatePassIn" },
      { element: <GatePassOut />, path: "/gatePassOut" },
      { element: <ProcurementReciept />, path: "/procurementReciept" },
      { element: <DirectFarmerInvoice />, path: "/farmerInvoice" },
      { element: <DirectFarmerPayment />, path: "/farmerPayment" },
      { element: <VehicleRegistration />, path: "/registration" },
      { element: <RentedInvoice />, path: "/rentedInvoice" },
      { element: <VehicleMaintenance />, path: "/vehicleMaintenance" },
      { element: <DeliveryDispatchDr />, path: "/deliveryDispatch" },
      { element: <DeliveryDispatchCL />, path: "/ddContainer" },
      { element: <Palletization />, path: "/palletization" },
      { element: <ContainerLoading />, path: "/containerLoading" },
      { element: <AQC />, path: "/aqc" },
      { element: <DPI />, path: "/dpi" },
      { element: <PSI />, path: "/psi" },
      { element: <CLS />, path: "/cls" },
      { element: <SQC />, path: "/sqc" },
      { element: <LotCreation />, path: "/lot" },
      { element: <CleaningWashing />, path: "/cleanWashing" },
      { element: <SortingGarding />, path: "/sortGrading" },
      { element: <PackingLabeling />, path: "/packingLabeling" },
      { element: <TobaccoProcessing />, path: "/tobaccoProcessing" },

      { element: <OverallWarehouse />, path: "/overallWarehouse" },
      { element: <WarehouseWiseStock />, path: "/warehouseWise" },
      { element: <HubStock />, path: "/hubstock" },
      { element: <UserWiseStock />, path: "/userWise" },
      { element: <PreCooling />, path: "/preCooling" },
      { element: <InventoryClosing />, path: "/inventoryClosing" },
      { element: <PhysicalInventory />, path: "/physicalInventory" },

      { element: <SampleApproval />, path: "/sampleApproval" },
      { element: <TestingLabs />, path: "/testByLab" },
      { element: <AtmosphereStorage />, path: "/cas" },
      { element: <UserProfile />, path: "/userProfile" },
      { element: <OrgProfile />, path: "/orgProfile" },

      //sales mis

      { element: <CustomerWiseSalesOrders />, path: "/misCustSalesOrder" },
      { element: <TotalInvoices />, path: "/misTotalInvoice" },
      { element: <SalesReturnMis />, path: "/misSalesReturn" },
      { element: <CreditDebitNoteReport />, path: "/misCDNote" },
      { element: <SalesDashboard />, path: "/SalesDashboard" },
      { element: <CustomersAns />, path: "/anaCustomers" },
      { element: <SalesOrderAns />, path: "/ansSalesOrder" },
      { element: <SalesInvoiceAns />, path: "/ansSalesInvoice" },
      { element: <Customers />, path: "/customers" },
      { element: <SalesOrder />, path: "/salesOrder" },
      { element: <SalesInvoice />, path: "/salesInvoice" },
      { element: <SalesReturn />, path: "/salesReturn" },
      { element: <SalesReturnInvoice />, path: "/salesReturnInvoice" },
      { element: <CreditDebitNote />, path: "/cdNote" },
      { element: <MarketSurvey />, path: "/marketSurvey" },
      { element: <ProductRequest />, path: "/productRequest" },
      { element: <VanStock />, path: "/vanStock" },
      { element: <AssignSalesRegion />, path: "/salesRegion" },
      { element: <SalesTarget />, path: "/salesTarget" },
      { element: <SalesBroadCastMessage />, path: "/salesNotification" },

      //
      { element: <GlobalGap />, path: "/globalGap" },
      { element: <InternalInspcection />, path: "/internalInspcection" },
      { element: <FarmInspcection />, path: "/farmInspcection" },
      { element: <RiskAssessment />, path: "/riskAssessment" },
      { element: <ProGlobalGap />, path: "/ProGlobalGap" },
      { element: <ProInternalInspcection />, path: "/ProInternalInspcection" },
      { element: <ProFarmInspcection />, path: "/ProFarmInspcection" },
      { element: <ProRiskAssessment />, path: "/ProRiskAssessment" },
      { element: <SalesBeatPlan />, path: "/salesBeatPlan" },
      { element: <GatePassInPrint />, path: "/gatepassinprint" },

      //Uplaod

      { element: <VendorUpload />, path: "/vendorupload" },
      { element: <EmployeeUpload />, path: "/employeeupload" },
      { element: <CustomerUpload />, path: "/customerupload" },
      {
        element: <FarmerUpload />,
        path: "/farmerupload",
      },
      { element: <FarmerPlotUpload />, path: "/farmerplotupload" },
      { element: <FarmerPlotUploadFMN />, path: "/farmerplotuploadfmn" },
      { element: <ProductUpload />, path: "/productupload" },
      { element: <FarmerUploadFMN />, path: "/farmeruploadfmn" },
      { element: <FarmerGoodsIssuedUploadFMN />, path: "goodsIssuedUploadFMN" },

      { element: <GanttChart />, path: "/ganttchart" },

      //finance mis

      { element: <CustomerLedger />, path: "/customerledger" },
      { element: <VendorLedger />, path: "/vendorledger" },
      { element: <GeneralLedger />, path: "/generalledger" },

      { element: <VoucherPayment />, path: "/voucherPayment" },
      { element: <VoucherDetailPayment />, path: "/voucherDetailPayment" },
      { element: <EmployeeExpenseReport />, path: "/employeeExpenseReport" },
      {
        element: <FarmerOpeningBalanceReport />,
        path: "/farmerOpeningBalanceReport",
      },

      //Agri Promotor

      {
        element: <AgriPromoterTarget />,
        path: "/agriPromoterTarget",
      },
      {
        path: "/hubstockInfo",
        element: <HubStockInfo />,
      },

      {
        path: "/hubstocktouser",
        element: <HubstockToMobileUser />,
      },

      {
        element: <AgriFarmerInspectionReport />,
        path: "/agriFarmerInspectionReport",
      },
      {
        element: <AgriCropCutReport />,
        path: "/agriCropCutReport",
      },
      {
        element: <HubSalesReport />,
        path: "/hubSalesReport",
      },

      //Media Registration

      {
        element: <MediaRegistration />,
        path: "/mediaRegistration",
      },
      {
        element: <NurseryStock />,
        path: "/nurseryStock",
      },
      {
        element: <OperationsReports />,
        path: "/operationsReports",
      },
      // Nursery Reports
      {
        element: <MotherPlant />,
        path: "/motherPlant",
      },
      {
        element: <NurseryTransfer />,
        path: "/nurseryTransfer",
      },
      { element: <NurseryObservationReport />,
        path: "/NurseryObservationReport",
      },
      { element: <NurserySowingInputReport />,
        path: "/NurserySowingInputReport",
      },
      { element: <NurserySowingOutputReport />,
        path: "/NurserySowingOutputReport",
      },
      {
        element: <LabourDetails />,
        path: "/labourDetails",
      },
    ],
  },
]);

export default router;